var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { title: "传输日志明细", visible: _vm.visible, width: "60%" },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.close,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("el-button", { on: { click: _vm.resetPush } }, [
                _vm._v("重推"),
              ]),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, inline: true, "label-width": "130px" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "主键id：", prop: "id" } },
                    [_vm._v(" " + _vm._s(_vm.form.id) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "第三方名称：", prop: "thirdName" } },
                    [_vm._v(" " + _vm._s(_vm.form.thirdName) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "节点名称：", prop: "flowNodeName" } },
                    [_vm._v(" " + _vm._s(_vm.form.flowNodeName) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "日志类型：", prop: "logName" } },
                    [_vm._v(" " + _vm._s(_vm.form.logName) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "业务id：", prop: "businessId" } },
                    [_vm._v(" " + _vm._s(_vm.form.businessId) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "动作：", prop: "action" } },
                    [_vm._v(" " + _vm._s(_vm.form.action) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间：", prop: "createTime" } },
                    [_vm._v(" " + _vm._s(_vm.form.createTime) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "更改时间：", prop: "updateTime" } },
                    [_vm._v(" " + _vm._s(_vm.form.updateTime) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "传输结果：", prop: "result" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "600px" },
                        attrs: { type: "textarea", rows: 4 },
                        model: {
                          value: _vm.form.result,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "result", $$v)
                          },
                          expression: "form.result",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "数据：", prop: "data" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "600px" },
                        attrs: { type: "textarea", rows: 20 },
                        model: {
                          value: _vm.form.data,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "data", $$v)
                          },
                          expression: "form.data",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }